export function getApiUrl() {
    return process.env.VUE_APP_API_URL;
}
